/**
 * The Library top-level tab.
 *
 * Contains sub-tabs for the user's private texts, the public library, and popular domains.
 */
import $ from "jquery";
import languageURLUpdate from "languageURLUpdate";
import * as localAPI from "localAPI";
import models from "models/models";
import * as mustcache from "mustcache";
import readlangClient from "readlangClient";
import * as languageMap from "shared/languageMap";
import * as signupModal from "signupModal";
import * as _ from "underscore";
import PopularDomainsView from "views/PopularDomainsView";
import PrivateLibraryView from "views/PrivateLibraryView";
import PublicLibraryView from "views/PublicLibraryView";

let containerElement;
let renderedCallback;
let appRouter;
let options;
let innerView;
let initialized;

const pageName = "homePage";
export const name = pageName;

const onLanguageChange = () => {
  languageURLUpdate(models.user.get("currentLearningLanguage"), appRouter);
};

const showUploadDialog = async () => {
  if (await localAPI.isLocalMode()) {
    signupModal.show({
      headingHtml: "<h2>Sign in to upload texts</h2>",
      models: models,
    });
    return;
  }

  appRouter.navigate("/upload", { trigger: true });
};

export const render = (
  _containerElement,
  _renderedCallback,
  _appRouter,
  _options
) => {
  containerElement = _containerElement;
  renderedCallback = _.once(_renderedCallback);
  appRouter = _appRouter;
  options = _options || {};
  _render();
};

var _render = async () => {
  if (!initialized) {
    models.user.on("change:currentLearningLanguage", onLanguageChange);
    initialized = true;
  }
  if (innerView) {
    innerView.remove();
  }
  const data = {
    user: models.user.toJSON(),
    hasPremium: models.user.hasPremiumAccess(),
    localMode: await localAPI.isLocalMode(),
  };
  mustcache.render("libraryPage", data, async (html) => {
    containerElement.html(html);

    containerElement
      .find('[data-pathname="/privateTexts"]')
      .click(async (event) => {
        if (await localAPI.isLocalMode()) {
          event.stopPropagation();
          event.preventDefault();
          signupModal.show({
            headingHtml: "<h2>Sign in to manage your texts</h2>",
            models: models,
          });
        }
      });

    // tab switching
    containerElement
      .find('.libraryViewTabBar li[data-pathname="/' + options.tab + '"]')
      .addClass("selected");
    containerElement.find("#addDocument").click(showUploadDialog);
    containerElement.find("#storyBot").click(() => {
      appRouter.navigate("/storyBot", { trigger: true });
    });

    let titleElement = $("title");
    let descriptionElement = $('meta[name="description"]');

    let currentLearningLanguageString =
      languageMap.map[models.user.get("currentLearningLanguage")].english;

    let InnerView;

    switch (options.tab) {
      case "privateTexts":
        if (await readlangClient.isLocalMode()) {
          appRouter.navigate("/library", { trigger: true });
          return;
        }

        localStorage.setItem("homePath", "/myTexts");
        localStorage.setItem("libraryOrDashboardPath", "/myTexts");

        titleElement.text(
          "Bookshelf - " + currentLearningLanguageString + " - Readlang"
        );
        descriptionElement.attr(
          "content",
          "Your private bookshelf of " +
            currentLearningLanguageString +
            " texts."
        );
        InnerView = PrivateLibraryView;
        break;
      case "publicTexts":
        localStorage.setItem("homePath", "/library");
        localStorage.setItem("libraryOrDashboardPath", "/library");
        titleElement.text(
          "Public Library - " + currentLearningLanguageString + " - Readlang"
        );
        descriptionElement.attr(
          "content",
          "Practice your " +
            currentLearningLanguageString +
            " with stories, articles, songs and videos. Click-to-translate & review vocabulary with flashcards."
        );
        InnerView = PublicLibraryView;
        break;
      case "popularDomains":
        localStorage.setItem("homePath", "/links");
        localStorage.setItem("libraryOrDashboardPath", "/links");
        titleElement.text(
          "Links - " + currentLearningLanguageString + " - Readlang"
        );
        descriptionElement.attr(
          "content",
          "A collection of links to the most recommended websites for practicing to read " +
            currentLearningLanguageString +
            "."
        );
        InnerView = PopularDomainsView;
        break;
      default:
        console.error("tab not recognised: ", options.tab);
    }

    // setting here so that css is correct while the subviews finish loading
    $("body").attr("id", pageName);

    innerView = new InnerView(
      _.extend(
        {
          models: models,
          el: containerElement.find("#homePageContent"),
          appRouter: appRouter,
          renderedCallback: _.once(renderedCallback),
        },
        options
      )
    );
  });
};

export const close = () => {
  if (innerView) {
    innerView.remove();
  }
  models.user.off("change:currentLearningLanguage", onLanguageChange);
  initialized = false;
};

export const showHeader = true;
